import { render, staticRenderFns } from "./MoveBanner.vue?vue&type=template&id=663e1e14&scoped=true&"
import script from "./MoveBanner.vue?vue&type=script&lang=js&"
export * from "./MoveBanner.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "663e1e14",
  null
  
)

export default component.exports